import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TimerAssistantContainer = _resolveComponent("TimerAssistantContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasSideBar())
      ? (_openBlock(), _createBlock(_component_SideBar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass())
    }, [
      _createVNode(_component_router_view),
      (_ctx.showTimerAssistant())
        ? (_openBlock(), _createBlock(_component_TimerAssistantContainer, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}